import { render, staticRenderFns } from "./ConfigureMfa.vue?vue&type=template&id=6b43ed7a&"
import script from "./ConfigureMfa.vue?vue&type=script&lang=js&"
export * from "./ConfigureMfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports